import { Box, LinearProgress, Skeleton, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import colors from "../../../config/colors";
import { ShiftsTodaySnapshot } from "../store/supervisor-home-types";
import RailCard from "./rail-card";

interface FlexCoverageCardProps {
	shiftsToday?: ShiftsTodaySnapshot;
	isLoading: boolean;
}

function FlexCoverageCard({ shiftsToday, isLoading }: FlexCoverageCardProps) {
	const { t } = useTranslation();
	// A day with nothing scheduled is fully covered, not 0% covered.
	const percentage =
		shiftsToday && shiftsToday.scheduled > 0
			? Math.round((shiftsToday.filled / shiftsToday.scheduled) * 100)
			: 100;

	return (
		<RailCard title={t("supervisor-home_flex-coverage-today")} highlighted>
			{isLoading || !shiftsToday ? (
				<Skeleton animation='wave' height={92} />
			) : (
				<>
					<Box sx={{ display: "flex", alignItems: "baseline", gap: 0.75 }}>
						<Typography sx={{ fontSize: "2rem", lineHeight: 1 }}>
							{percentage}%
						</Typography>
						<Typography sx={{ fontSize: "13px", color: colors.gray }}>
							{t("supervisor-home_of-slots-filled")}
						</Typography>
					</Box>

					<LinearProgress
						variant='determinate'
						value={percentage}
						aria-label={t("supervisor-home_flex-coverage-today")}
						sx={{
							height: "8px",
							borderRadius: "4px",
							my: 1.5,
							backgroundColor: colors.grey,
							"& .MuiLinearProgress-bar": {
								backgroundColor: colors.button,
							},
						}}
					/>

					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							fontSize: "13px",
							color: colors.title,
						}}
					>
						<Typography sx={{ fontSize: "13px" }}>
							{t("supervisor-home_filled-count", {
								count: shiftsToday.filled,
							})}
						</Typography>
						<Typography sx={{ fontSize: "13px" }}>
							{t("supervisor-home_open-count", { count: shiftsToday.open })}
						</Typography>
						<Typography sx={{ fontSize: "13px" }}>
							{t("supervisor-home_scheduled-count", {
								count: shiftsToday.scheduled,
							})}
						</Typography>
					</Box>
				</>
			)}
		</RailCard>
	);
}

export default FlexCoverageCard;
